<template>
  <div class="system-health">
    <div class="health-header">
      <h3><i class="fas fa-heartbeat"></i> System Health</h3>
      <p>System status monitor and maintenance tools.</p>
    </div>
    
    <div class="coming-soon">
      <div class="icon-wrapper">
        <i class="fas fa-stethoscope"></i>
      </div>
      <h4>Health Monitor in Development</h4>
      <p>The system health monitor will include:</p>
      <ul>
        <li>MongoDB database status</li>
        <li>API performance metrics</li>
        <li>Disk space usage</li>
        <li>System error logs</li>
        <li>Automatic cleanup tools</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
// Placeholder component for system health
</script>

<style scoped>
.system-health {
  padding: 40px;
  text-align: center;
}

.health-header {
  margin-bottom: 50px;
}

.health-header h3 {
  color: #2c3e50;
  margin-bottom: 10px;
  font-size: 1.5rem;
}

.health-header p {
  color: #6c757d;
  font-size: 1rem;
}

.coming-soon {
  max-width: 500px;
  margin: 0 auto;
  padding: 40px;
  background: #f8f9fa;
  border-radius: 20px;
  border: 2px dashed #dee2e6;
}

.icon-wrapper {
  margin-bottom: 20px;
}

.icon-wrapper i {
  font-size: 3rem;
  color: #6c757d;
}

.coming-soon h4 {
  color: #495057;
  margin-bottom: 15px;
}

.coming-soon p {
  color: #6c757d;
  margin-bottom: 20px;
}

.coming-soon ul {
  text-align: left;
  color: #6c757d;
  list-style: none;
  padding: 0;
}

.coming-soon li {
  padding: 5px 0;
  position: relative;
  padding-left: 20px;
}

.coming-soon li::before {
  content: '•';
  color: #dc3545;
  position: absolute;
  left: 0;
  font-weight: bold;
}
</style>